import { InfoCircle } from "@untitledui/icons"

/**
 * What the template chooser means when it is setting the class's default rather than replacing
 * today's lesson. The two views are the same list of templates, so nothing in the rows themselves
 * says which one you are in — and the difference is the whole reason someone would hesitate.
 *
 * It stays up while templates are chosen, because the view does: pressing a row moves the check
 * rather than dismissing anything, so the caveat is still on screen when the choice lands.
 *
 * Shaped like the card menu's public callout (see CardPublicCallout), amber rather than mint: this
 * is the scope of a choice about to be made, not applause for one already made. A neutral grey
 * would be the obvious choice and is the wrong one — the menu behind it is white, so gray-50 has
 * no edge to read against and the note ghosts.
 */
export function DefaultTemplateNote() {
  return (
    // Inset to the row's own padding, so the box lines up with the labels below it.
    <div
      data-test="default template note"
      className="mx-[var(--menu-row-inset,1.75rem)] mt-1 mb-2 flex items-start gap-2.5 rounded-xl bg-warning-primary px-3 py-2.5"
    >
      <InfoCircle className="mt-0.5 size-4 shrink-0 text-fg-warning-primary" strokeWidth={2} />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="m-0 text-[0.9375rem] leading-tight font-bold text-black">
          Only brand new lessons use the default
        </p>
        <p className="m-0 text-[0.8125rem] leading-snug text-gray-700">
          Everything you’ve already written stays put.
        </p>
      </div>
    </div>
  )
}
